module.exports = __webpack_public_path__ + "img/799-caf890.png";